import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { NvIconModule } from '../nv-icon/nv-icon.module';
import { NvButtonComponent } from './nv-button.component';

@NgModule({
  imports: [CommonModule, MatRippleModule, NvIconModule],
  declarations: [NvButtonComponent],
  exports: [NvButtonComponent],
})
export class NvButtonModule {}
